module.exports = __webpack_public_path__ + "media/images/logo-56653337f14b97612f742f9cc4d04e29.png";